import { TranslateService } from '@ngx-translate/core';
import { LoyaltyCatalogGiftReceivedStoreAllService } from './../../../services/loyalty/loyalty-catalog-gift-received-store-all.service';
import { CommonService } from './../../../services/utils/common.service';
import { CalendarTranslateService } from './../../../modules/UIKit/services/calendarTranslate.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { KontableComponent } from "../../../modules/UIKit/components/kontable/kontable.component";
import { LoyaltyCatalogGiftReceivedStoreService } from 'app/services/loyalty/loyalty-catalog-gift-received-store.service';
import { AuthService } from 'app/services/user/auth.service';
import { Router } from "@angular/router";

@Component({
  selector: 'app-loyalty-catalog-received-store-type',
  templateUrl: './loyalty-catalog-gift-received-store.component.html',
  styleUrls: ['./loyalty-catalog-gift-received-store.component.css']
})
export class CatalogGiftReceivedStoreComponent implements OnInit {
  paginationType = KontableComponent.ServerPagination;
  customFilter = KontableComponent.CustomFilter;
  selectFilter = KontableComponent.SelectFilter;
  dateFilter = KontableComponent.DateFilter;

  reservationTypes: Array<{value: number, label: string}> = [];

  storeId: any;
  headId: any;
  userId: any;
  language: string;

  filterDateReceived: Date;
  @ViewChild('table') table: any;

  showAllResults = false;
  service: any;

  constructor(
    public catalogService: LoyaltyCatalogGiftReceivedStoreService,
    public catalogGiftReceivedStoreAllService: LoyaltyCatalogGiftReceivedStoreAllService,
    private router: Router,
    private authService: AuthService,
    public calendarTranslateService: CalendarTranslateService,
    private commonService: CommonService,
    private translateService: TranslateService
  ) {
    this.userId = this.authService.user.id.toString();
    //this.userId = '1';
    this.catalogService.userId = this.catalogGiftReceivedStoreAllService.userId = this.userId;
    this.language = this.authService.user.language;
    this.service = this.catalogService;
  }


  ngOnInit() {
    this.getParamState();
  }


  /**
   * Metodo per la visualizzazione della pagina di modifica
   * di una specifica ricezione premi
   * @param id l'head_id della ricezione da modificare
   */
  editCatalog(id: number) {
    this.router.navigate([`loyalty/catalog-gift-received-store/detail/${id}`]);
  }


  /**
   * Metodo per la visualizzazione della pagina con il forma di aggiunta
   * di una specifica ricezione premi
   */
  addCatalog() {
    this.router.navigate(['loyalty/catalog-gift-received-store/detail']);
  }


  /**
   * Metodo per la visualizzazione della pagina di dettaglio
   * per una determinata ricezione
   * @param id l'id del record di cui si vuole vedere il dettaglio
   */
  showDetails(id: number){
    this.catalogService.getCatalogGiftData(id).subscribe(res=>{
      this.storeId = res[0].store_id,
      this.headId = res[0].id,
      this.router.navigate([`loyalty/catalog-gift-assigned/${this.storeId}/${this.headId}`])
    });
  }

  /**
   * Metodo per recuperare le descrizioni per il campo stato ricezione premi in negozio in base alla lingua dell'utente
   */
  getParamState(){
    this.translateService.get(['common.all']).subscribe(res => {
      this.reservationTypes.push({label: res['common.all'], value: null});
      this.catalogService.getParamTypes('reservation_store', this.language).subscribe(resTypes => {
        resTypes.forEach(resType => this.reservationTypes.push({value: resType.param_code, label: resType.description}))
      });
    });
  }

  getResults(all: boolean) {
    this.service = all ? this.catalogGiftReceivedStoreAllService : this.catalogService;
    // Timeout per evitare refresh della table prima dell'aggiornamento del service
    setTimeout(() => {
      this.table.clearFilters();
    }, 300);
    this.showAllResults = all;
  }

}



// WEBPACK FOOTER //
// ./src/app/views/loyalty/loyalty-catalog-gift-received-store/loyalty-catalog-gift-received-store.component.ts